var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"changelocale"},[_c('b-btn',{style:([!_vm.open ? 'color: black':'color: white; padding-left: 0px;']),attrs:{"variant":"link"},on:{"click":function($event){return _vm.switchLocale(_vm.otherlocale)}}},[_vm._v(_vm._s(_vm.otherlocale))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9d16b054","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/buttons/ChangeLocale.vue
// module id = 636
// module chunks = 1